export enum ActionDGAGEnum {
  AUCUNE_ACTION = 'aucuneAction',
  RECEVOIR_APPEL = 'recevoirAppel',
  APPELER = 'appeler',
}
